// extracted by mini-css-extract-plugin
export default {"card":"L3-z","carousel":"M3-z"};